import axios from 'axios';

import settings from '../libs/config';
import ApiError from './apiError.js';

const endpoint = settings.api_host + "/episode/get";

export const getEpisode = async (episodeId, user_token) => {
	if (!episodeId) {
		throw new Error("Missing Episode ID");
	}
	try {
		const response = await axios.get(endpoint, {
			params: {
				user_token,
				episodeId
			}
		});

		const data = response.data;
		return data.result;
	} catch (error) {
		throw new ApiError(error);
	}
};


// WEBPACK FOOTER //
// ./src/api/episode.js